import { render, staticRenderFns } from "./ContenedorCampos.vue?vue&type=template&id=e0d9e184&scoped=true"
import script from "./ContenedorCampos.vue?vue&type=script&lang=js"
export * from "./ContenedorCampos.vue?vue&type=script&lang=js"
import style0 from "./ContenedorCampos.vue?vue&type=style&index=0&id=e0d9e184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d9e184",
  null
  
)

export default component.exports